const socialLinks = [
  {
    href: "https://www.facebook.com/idjshowofficial",
    className: "idj-facebook",
    label: "Facebook",
  },
  {
    href: "http://instagram.com/idjshow",
    className: "idj-instagram",
    label: "Instagram",
  },
  {
    href: "https://www.youtube.com/channel/UCk2KpORpz6HzhBDso4K9aTA",
    className: "idj-youtube",
    label: "YouTube",
  },
  { href: "http://x.com/idjshowcom", className: "idj-x", label: "X (Twitter)" },
  {
    href: "http://tiktok.com/@idjshow",
    className: "idj-tik-tok",
    label: "TikTok",
  },
];

export const Footer = () => (
  <footer className="social-media">
    <ul className="social-media-links">
      {socialLinks.map(({ href, className, label }) => (
        <li key={className}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`icon ${className}`}
            aria-label={label}
          />
        </li>
      ))}
    </ul>
    <div
      style={{
        alignItems: "center",
        display: "flex",
      }}
    >
      <span
        style={{
          textAlign: "center",
          fontSize: 14,
          color: "white",
          fontFamily: "Inter, sans-serif",
        }}
      >
        IDJShow &copy; Copyright IDJTV {new Date().getFullYear()}. Sva prava
        zadržana.
      </span>
    </div>
  </footer>
);
